<template>
  <div class="vx-card" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '23') != null">
    <h1 class="card-bg p-6 text-center mt-4">HESAP HAREKETİ YÖNETİMİ</h1>
    <div class="proje_cards pt-6 mb-5">
      <div class="proje_card left mb-5">
        <h2 class="card-bg p-6 mb-3 text-center hoverHeading" @click="showSearchAccountMovement = !showSearchAccountMovement">
          <span class="mr-2"><feather-icon icon="SearchIcon" svgClasses="h-6 w-6" /></span><span>Hesap Hareketi Arama</span>
        </h2>

        <div v-if="showSearchAccountMovement" class="card-bg p-5">
          <form @submit.prevent="getAccountMovement()">
            <div class="inputs tFlex tFlex_ai-s gap-1 mb-5">
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Id</b></label>
                <vs-input type="number" style="width: 100%;" v-model="accountMovementSearch.id" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Module Id</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountMovementSearch.moduleId" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Module Line Id</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountMovementSearch.moduleLineId" />
              </div>
              <div class="flex-1 gap-3 mb-5">
                <label class="text-sm mb-3"><b>Ürün Id</b></label>
                <vs-input type="text" style="width: 100%;" v-model="accountMovementSearch.productId" />
              </div>
            </div>

            <div class="tFlex tFlex_column tFlex_ai-c tFlex_jc-c mb-3 gap-1">
              <vs-button color="success" class="width-110">Ara</vs-button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="card-bg mb-5 p-5">
      <h2 class="text-center hoverHeading">
        <span class="mr-2"><feather-icon icon="BriefcaseIcon" svgClasses="h-6 w-6" /></span><span>Hesap Hareketleri</span>
      </h2>

      <div class="vx-row w-full">
        <div class="vx-col w-full mb-5">
          <vs-table search :maxItems="10" :pagination="true" :data="accountMovement">
            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Module Id</vs-th>
              <vs-th>Module Line Id</vs-th>
              <vs-th>Ürün Id</vs-th>
              <vs-th>Maliyet</vs-th>
              <vs-th>Maliyet Döviz Türü</vs-th>
              <vs-th>Maliyet Döviz Kuru</vs-th>
              <vs-th>Satış Fiyatı</vs-th>
              <vs-th>Satış Döviz Türü</vs-th>
              <vs-th>Satış Döviz Kuru</vs-th>

              <vs-th>İşlemler</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(tr, i) in data">
                <template v-if="tr.id">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.id }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.moduleId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.moduleLineId }}</b>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ tr.productId }}</b>
                  </vs-td>

                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input style="width: 100px;" type="number" v-model="tr.owningCost" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <v-select style="width: 100px;" name="Id" v-model="tr.owningCostCurrencyId" :options="moneyCurrencyOptions" label="name" :reduce="(row) => row.id"> </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input style="width: 100px;" type="number" v-model="tr.owningCostCurrencyFxRate" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input style="width: 100px;" type="number" v-model="tr.salePrice" />
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <v-select style="width: 100px;" name="Id" v-model="tr.salePriceCurrencyId" :options="moneyCurrencyOptions" label="name" :reduce="(row) => row.id"> </v-select>
                  </vs-td>
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <vs-input style="width: 100px;" type="number" v-model="tr.salePriceCurrencyFxRate" />
                  </vs-td>

                  <vs-td style="width: 10%;">
                    <!-- <feather-icon icon="TrashIcon" title="Sil" svgClasses="h-6 w-6 hover:text-warning text-danger cursor-pointer" @click.stop="SaveRouter(tr, 'Delete', 'Router silinecektir')" /> -->
                    <feather-icon icon="EditIcon" title="Güncelle" svgClasses="h-6 w-6 ml-5 hover:text-warning text-success cursor-pointer" @click.stop="SaveAccountMovement(tr, 'Update', '')" />
                  </vs-td>
                </template>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";

// Cell Renderer

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      accountMovement: [],
      accountMovementSearch: { id: null, moduleId: null, moduleLineId: null, productId: null },

      showAddAccountMovement: false,
      showSearchAccountMovement: false,
      moneyCurrencyOptions: [],
    };
  },

  computed: {},
  methods: {
    getAccountMovement: async function () {
      this.$vs.loading();
      this.accountMovement = await repository.postEntity("ParametricScreens/GetAccountMovement", this.accountMovementSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getCurrencies: async function () {
      this.moneyCurrencyOptions = await repository.getAll("Accounting/getCurrencies").then((r) => r.list);
    },

    SaveAccountMovement: async function (item, operation, messageText) {
      //Insert,Update,Delete
      item.operation = operation;

      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;

      this.$vs.loading();
      await repository.postEntity("ParametricScreens/SaveAccountMovement", item);

      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });

      this.accountMovementSearch = {};
      this.getAccountMovement();
    },
  },

  beforeMount() {},
  beforeUpdate() {},
  mounted() {},
  created: async function () {
    this.$vs.loading();
    await Promise.all([this.getAccountMovement(), this.getCurrencies()]);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss">
body {
  overflow: auto;
}
.vs-dialog {
  max-width: 1366px !important;
  max-height: 95% !important;
}
</style>
